import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, List, Popconfirm, Space, Typography } from 'antd';
import { CopyOutlined, DeleteOutlined, PlusOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import styles from './index.module.scss';

const { Text } = Typography;

const ToolHistorySidebar = ({
  title,
  items,
  activeId,
  onSelect,
  onCreate,
  onDuplicate,
  onDelete,
  disableDelete,
  collapsed,
  onToggleCollapse,
}) => {
  const { t } = useTranslation();

  return (
    <aside className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''}`}>
      <div className={styles.header}>
        <div className={styles.headerRow}>
          {!collapsed && <h3 className={styles.title}>{title || t('tools.common.processingHistory')}</h3>}
          <Button
            size="small"
            type="text"
            className={styles.toggleBtn}
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={onToggleCollapse}
            title={collapsed ? t('tools.common.expandSidebar') : t('tools.common.collapseSidebar')}
          />
        </div>

        {!collapsed && (
          <Space size="small">
            <Button size="small" icon={<PlusOutlined />} onClick={onCreate}>
              {t('tools.common.newConfig')}
            </Button>
            <Button size="small" icon={<CopyOutlined />} onClick={onDuplicate}>
              {t('tools.common.duplicate')}
            </Button>
          </Space>
        )}
      </div>

      {!collapsed && (
        <List
          className={styles.list}
          dataSource={items}
          locale={{ emptyText: t('tools.common.noHistory') }}
          renderItem={(item) => (
            <List.Item
              className={`${styles.item} ${item.id === activeId ? styles.active : ''}`}
              onClick={() => onSelect(item.id)}
              actions={[
                <Popconfirm
                  key="delete"
                  title={t('tools.common.deleteConfigConfirm')}
                  onConfirm={(evt) => {
                    evt?.stopPropagation?.();
                    onDelete(item.id);
                  }}
                  onCancel={(evt) => evt?.stopPropagation?.()}
                  disabled={disableDelete}
                >
                  <Button
                    size="small"
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    disabled={disableDelete}
                    onClick={(evt) => evt.stopPropagation()}
                  />
                </Popconfirm>,
              ]}
            >
              <div className={styles.itemContent}>
                <Text className={styles.itemName} ellipsis>
                  {item.snapshot?.axisConfig?.name || item.name}
                </Text>
                <Text className={styles.itemTime} type="secondary">{new Date(item.updatedAt).toLocaleString()}</Text>
              </div>
            </List.Item>
          )}
        />
      )}
    </aside>
  );
};

export default ToolHistorySidebar;
